import { render } from "./SwitchNetworkModal.vue?vue&type=template&id=26ac1cd3&scoped=true"
import script from "./SwitchNetworkModal.vue?vue&type=script&lang=js"
export * from "./SwitchNetworkModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/connectionAndPolygonModal.scss?vue&type=style&index=0&id=26ac1cd3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ac1cd3"]])

export default __exports__